import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=43919a5a&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=ts"
export * from "./MemberDetails.vue?vue&type=script&lang=ts"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=43919a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43919a5a",
  null
  
)

export default component.exports